// config.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private _baseUrl: string = '';

  constructor(private http: HttpClient) {}

  getConfig() {
    return this.http.get<any>(`/config/config.json`);
  }

  get baseUrl(): string {
    return this._baseUrl;
  }

  set baseUrl(value: string) {
    this._baseUrl = value;
  }
}
